import type { MuiTelInputCountry, MuiTelInputFlagElement } from 'mui-tel-input';

export const getCountryFlagEmoji = (isoCode: string): string =>
  isoCode
    .toUpperCase()
    .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt(0)));

export const getPhoneFlagElement = (
  isoCode: MuiTelInputCountry,
  { countryName }: { countryName: string },
): MuiTelInputFlagElement => (
  <span
    className="MuiTelInput-FlagImg inline-flex text-xl leading-none"
    role="img"
    aria-label={countryName}
  >
    {getCountryFlagEmoji(isoCode)}
  </span>
);

export const unknownPhoneFlagElement: MuiTelInputFlagElement = (
  <span
    className="MuiTelInput-FlagImg inline-flex h-[18px] w-[26px] items-center justify-center rounded-[2px] bg-neutral-100 text-[10px] font-semibold text-neutral-300"
    role="img"
    aria-label="Unknown country"
  >
    ?
  </span>
);
